<template>
  <div class="content-wrapper" :class="cssStyle">
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="content-wrapper__underlay"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogContent',
  props: {
    cssStyle: String
  }
})
</script>

<style lang="scss" scoped>
@mixin content-style($bgColor, $borderStyle) {
  border: $borderStyle;
  .content-wrapper__underlay {
    background-color: $bgColor;
  }
}

.content-wrapper {
  position: relative;
  height: 30vh;
  border-radius: 3px;
  margin: 16px 0;

  @media (max-width: 599px) {
    margin: 0;
  }

  &:hover {
    &.first-style {
      border-style: solid;
      .content-wrapper__underlay {
        opacity: 1;
      }
    }
  }

  &__underlay {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.12;
  }

  @media (max-width: 599px) {
    height: 35vh !important;
  }

  @media (max-height: 469px) {
    height: 25vh !important;
  }

  @media (min-height: 1000px) {
    height: 18rem !important;
  }

  &.first-style {
    @include content-style(
      var(--tsi-color--main-primary),
      dotted 4px var(--tsi-color--main-primary)
    );
  }

  &.second-style {
    @include content-style(
      var(--tsi-color--main-primary),
      solid 2px var(--tsi-color--main-primary)
    );
  }

  &.third-style {
    @include content-style(
      var(--tsi-color--accent-error),
      solid 2px var(--tsi-color--accent-error)
    );
  }

  &.fourth-style {
    @include content-style(
      var(--tsi-color--accent-success),
      solid 2px var(--tsi-color--accent-success)
    );
  }

  &.fifth-style {
    @include content-style(var(--tsi-color--dark-36), solid 2px var(--tsi-color--dark-36));
  }

  .content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--tsi-color--dark-36);
      border-radius: 10px;
    }

    > * {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
